module.exports = __webpack_public_path__ + "img/hip_roof_one.22f1939e.jpg";